import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { message, Pagination, Input, Form, Select, Row, Col, DatePicker, InputNumber, Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
import ListinngCard from '../../layouts/ListingCard';

function FacialPatientListing() {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const [addForm] = Form.useForm();
  let searchedUser;
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [fetchUsers, setFetchUsers] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState({});
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  // const [searchItems, setSearchItems] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [err, setErr] = useState('');

  const patientListingApi = async (formData) => {
    setLoader(true);
    const userResp = await axios.post(`${app.URL}/api/v1/admin/patient/faciallisting`, formData, { headers: getHeaders() });
    
    // const userResp = await axios.post(`${app.URL}/api/v1/admin/patient/listing`, formData, { headers: getHeaders() });
    userResp.data.result ? setFetchUsers(userResp.data.result.data) : ' ';
    userResp.data.result ? setPagesCount(userResp.data.result.data.count) : ' ';
    userResp.data.result ? setRenderList(userResp.data.result.data.data) : ' ';
    userResp.data.result && setLoader(false);
  };

  const userList = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user.userType === 'A') setEditBtn('block');
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: 'firstName',
      searchTxt: '',
    };
    await patientListingApi(formData);
  };
  useEffect(() => {
    let header = ['Customer Name',  'Email','Reward Count',  'Action'];
    setTableHeaders(header);
    setLoader(true);
    userList();
    // setSearchItems(searchFilters);
  }, []);
  let searchItems = [
    {
      name: 'Name',
      value: 'firstName',
    },
    {
      name: 'Email',
      value: 'email',
    },
  
  ];
  
  const onChange = async (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;

    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: searchShow.searchBy,
          searchTxt: searchShow.searchTxt,
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: 'firstName',
          searchTxt: '',
        };
      }

      await patientListingApi(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  const onFinish = async (values) => {
    setSearchShow(values);
     let formData = {
       limit: 10,
       offset: 0,
       searchBy: values.searchBy,
       searchTxt: values.searchTxt,
     };
     if (!formData.searchTxt) message.error('Please enter search text');
     else await patientListingApi(formData);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleSearchChange = (e) => {
    if (!e.target.value) {
      setRenderList(fetchUsers.slice(0, 10));
      //  console.log(organizations.length)
      setPagesCount(fetchUsers.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editPatient = (e) => {
    localStorage.setItem('editPatientId', JSON.stringify(e.patientId));
    if (e?.email) {
      localStorage.setItem('facialScanEmail', e.email);
    }
    navigate('/facial-scan/get', { state: { email: e?.email, patientId: e?.patientId } });
  };
  const addPatient = () => {
    navigate('/patient/create', { replace: true });
  };

  const handleAddFacialScan = async (values) => {
    try {
      setAddLoading(true);

      const payload = {
        email: values.email,
        scanCounts: values.scanCounts,
        expiryDate: values.date.format('YYYY-MM-DD'),
      };

    let respo=  await axios.get(`${app.URL}/api/v1/static/addfacialreward?isWeb=true&email=${payload.email}&facialScans=${payload.scanCounts}&expiryDays=${payload.expiryDate}`);

      message.success('Facial reward added successfully');

      setOpenModal(false);
      addForm.resetFields();

      // Refresh list
      userList();
    } catch (error) {
      console.log("error",error?.response);

      message.error(error?.response?.data?.result?.msg || 'Something went wrong');
    } finally {
      setAddLoading(false);
    }
  };

  console.log(renderList);

  const handleOnChange = (e) => {
    if (e.target.value.length === 0) {
      userList();
      setSearchShow({});
    }
  };

  return (
    <>
      <ListinngCard
        loader={loader}
        onChange={handleOnChange}
        buttonName='Add Facial Scan'
        addButton={() => setOpenModal(true)}
        heading='Facial Scan Management'
        onSearch={onFinish}
        onSearchFailed={onFinishFailed}
        searchItems={searchItems}
        tableHeaders={tableHeaders}
        tableRows={renderList}
        editButton={editPatient}
        onPageChange={onChange}
        currentPage={currentPage}
        pagesCount={pagesCount}
        facialListing={true}
      />

      {/* ADD FACIAL SCAN MODAL */}
      <Modal
        title='Add Facial Scan'
        open={openModal}
        onCancel={() => {
          setOpenModal(false);
          addForm.resetFields();
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={addForm} layout='vertical' onFinish={handleAddFacialScan}>
          {/* EMAIL */}
          <Form.Item
            label='Email'
            name='email'
            rules={[
              {
                required: true,
                message: 'Please enter email',
              },
              {
                type: 'email',
                message: 'Please enter valid email',
              },
            ]}
          >
            <Input placeholder='Enter email' size='large' />
          </Form.Item>

          {/* SCAN COUNT */}
          <Form.Item
            label='Scan Count'
            name='scanCounts'
            rules={[
              {
                required: true,
                message: 'Please enter scan count',
              },
            ]}
          >
            <InputNumber placeholder='Enter scan count' min={1} size='large' style={{ width: '100%' }} />
          </Form.Item>

          {/* DATE */}
          <Form.Item
            label='Expiry Date'
            name='date'
            rules={[
              {
                required: true,
                message: 'Please select expiry date',
              },
            ]}
          >
            <DatePicker
              style={{ width: '100%' }}
              size='large'
              disabledDate={(current) => {
                return current && current < dayjs().startOf('day');
              }}
            />
          </Form.Item>

          {/* SUBMIT */}
          <Form.Item className='mb-0'>
            <div className='d-flex justify-content-end gap-2'>
              <Button
                onClick={() => {
                  setOpenModal(false);
                  addForm.resetFields();
                }}
              >
                Cancel
              </Button>

              <Button type='primary' htmlType='submit' loading={addLoading}>
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default FacialPatientListing;
